import { useSelector } from "react-redux";
import { Link } from "react-router-dom";
import { useGetSettingQuery } from "../../Redux/Apis/siteApi";
import Cart from "./Cart";

export default function Navbar(){
    const { cart } = useSelector( state => state )
    const {data : {name, menu}} = useGetSettingQuery()

    return(
        <>
        <nav className="navbar navbar-expand-lg navbar-light bg-light">
            <div className="container px-4 px-lg-5">
                <a className="navbar-brand" href="#!">{name}</a>
                <button className="navbar-toggler" type="button" data-bs-toggle="collapse" data-bs-target="#navbarSupportedContent" aria-controls="navbarSupportedContent" aria-expanded="false" aria-label="Toggle navigation"><span className="navbar-toggler-icon"></span></button>
                <div className="collapse navbar-collapse" id="navbarSupportedContent">
                    <ul className="navbar-nav me-auto mb-2 mb-lg-0 ms-lg-4">
                        {menu.map((row,index) => 
                            <div key={index}>
                                {!row.value.includes("#") && <li className="nav-item">
                                    <Link to={`${row.value}`} className="nav-link">{row.key}</Link>
                                </li>}
                            </div>
                        )}
                    </ul>
                    <div className="d-flex">
                        <button data-toggle="modal" data-target="#modal_aside_right" className="btn btn-outline-dark" type="button">
                            <i className="bi-cart-fill me-1"></i>
                            سبد خرید
                            <span className="badge bg-dark text-white ms-1 rounded-pill">{cart.data.length}</span>
                        </button>
                    </div>
                </div>
            </div>
        </nav>
        <Cart data={cart}/>
        </>
    )
}